
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import { CfetErrorMessagesConstant } from '../constants/cfet-error-messages.constant';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  public errorMessage = new BehaviorSubject(null);
  public showError = new BehaviorSubject(null);
  public showInfoLink = new BehaviorSubject<any>(null);
  public hideXicon = new BehaviorSubject<any>(null);
  public isErrorBannerOpened : boolean;

  constructor(private router: Router) {
    if (this.showError) {
      router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.hideError();
        }
      });
    }
  }

  public getErrorObj(error) {
    return (error && error.error && (error.error.errors || JSON.parse(error.error).errors)) ?
      (error.error.errors || JSON.parse(error.error).errors) : '';
  }

  public displayError(error?: any) {

    let eMsgs = [];
    const errorObj = this.getErrorObj(error);
    if (errorObj && Object.keys(errorObj).length > 0) {
      for (const errObj of errorObj) {
         // eslint-disable-next-line guard-for-in
          for (const key in errObj) {
            const msgs = errObj[key].map(err => {
              return CfetErrorMessagesConstant.CFET_ERROR_MESSAGES[err.code]
                ? CfetErrorMessagesConstant.CFET_ERROR_MESSAGES[err.code]
                : err.message;
            });
            eMsgs = [...eMsgs, ...msgs];
          }
       }
    } else {
      const msgs = [CfetErrorMessagesConstant.CFET_DEFAULT_ERROR_MESSAGE];
      eMsgs = [...eMsgs, ...msgs];
    }
    this.showError.next(true);
    this.errorMessage.next(eMsgs);
    window.scrollTo(0, 0);
  }

  ParseingErrObject(errorObj: any) {
    let tempErrObj: any = [];
    if (typeof (errorObj) !== 'string' && errorObj && errorObj.errorcode && errorObj.message) {
      const localObj: any = {};
      localObj.code = errorObj.errorcode;
      localObj.message = errorObj.message;
      tempErrObj.push(localObj);
    } else if (typeof (errorObj) !== 'string' && errorObj && errorObj.error && errorObj.error.errorcode && errorObj.error.message) {
      const localObj: any = {};
      localObj.code = errorObj.error.errorcode;
      localObj.message = errorObj.error.message;
      tempErrObj.push(localObj);
    } else if (typeof (errorObj) !== 'string' && errorObj && errorObj.error
      && typeof (errorObj.error) !== 'string' && errorObj.error.errors) {
      const errorObj1 = errorObj.error.errors;
      if (errorObj1) {
        tempErrObj = this.commonBlock(errorObj1);
      }
    } else if (typeof (errorObj) !== 'string' && errorObj && errorObj.error
      && typeof (errorObj.error) === 'string' && errorObj.error.errors) {
      const errorObj2 = JSON.parse(errorObj.error).errors;
      if (errorObj2) {
        tempErrObj = this.commonBlock(errorObj2);
      }
    }
    return tempErrObj;
  }

  commonBlock(error) {
    const tempErrObj1: any = [];
    for (const errObj of error) {
      // eslint-disable-next-line guard-for-in
      for (const key in errObj) {
        tempErrObj1.push(errObj[key][0]);
      }
    }
    return tempErrObj1;
  }

  displayErrorBasedOnCode(code) {
    const errorMessages: any = [];
    for (const val of CfetErrorMessagesConstant.CFET_ERROR_MESSAGES_LIST) {
      if (val.code === code) {
        errorMessages.push(...val.msg);
        break;
      }
    }
    if (errorMessages && errorMessages.length === 0) {
      errorMessages.push(CfetErrorMessagesConstant.CFET_DEFAULT_ERROR_MESSAGE);
    }
    this.showError.next(true);
    this.errorMessage.next(errorMessages);
    window.scrollTo(0, 0);
  }

  public displayValidationError(response: any[]) {
    let eMsgs = [];
    let msgs: string[] = response.map((obj: any) => obj.message);
    if (msgs && msgs.length > 0) {
      eMsgs = [...eMsgs, ...msgs];
    } else {
      msgs = CfetErrorMessagesConstant.CFET_DEFAULT_ERROR_MESSAGE;
      eMsgs = [...eMsgs, ...msgs];
    }
    this.showError.next(true);
    this.errorMessage.next(eMsgs);
  }

  displayErrorMessage(message: string) {
    this.showError.next(true);
     this.showError.subscribe(val => {
      this.isErrorBannerOpened = val;
     });
    this.errorMessage.next(message);
  }

  displayErrorMessageList(messages: string[]) {
    this.showError.next(true);
    this.errorMessage.next(messages);
  }

  displayErrorInfoMessage(messages: any, infoLink: any, hidexicon: any) {
    this.showError.next(true);
    this.errorMessage.next(messages);
    this.showInfoLink.next(infoLink);
    this.hideXicon.next(hidexicon);
  }

  public hideError() {
    this.showError.next(false);
  }
}
